export default {
    'films-category': require('./FilmsCategoryController'),
    'home': require('./HomeController'),
    'master': require('./MasterController'),
}
